import { useEffect, useState } from 'react';

export default (intervalMs = 60000) => {
  const [isNewVersion, setIsNewVersion] = useState(false);

  useEffect(() => {
    const checkVersion = async () => {
      try {
        const res = await fetch('/version.json', { cache: 'no-store' });
        const data = await res.json();

        const localVersion = sessionStorage.getItem('app_version');

        if (localVersion && data.version !== localVersion) {
          setIsNewVersion(true);
        }

        sessionStorage.setItem('app_version', data.version);
      } catch (err) {
        console.error('Błąd przy sprawdzaniu wersji:', err);
      }
    };

    checkVersion();
    const interval = setInterval(checkVersion, intervalMs);

    return () => clearInterval(interval);
  }, [intervalMs]);

  return isNewVersion;
};
